import Vue from "vue"
import Router from "vue-router"
import Home from "@/views/Home"
import store from "./store"

Vue.use(Router)

const RouterView = { render: (c) => c("router-view") }

const router = new Router({
  mode: "history",
  routes: [
    {
      name: "Home",
      path: "/",
      component: Home,
    },
    {
      path: "/card-:id",
      component: () => import("@/components/CCard"),
      // component: RouterView,
      props: true,
    },
    {
      path: "/dashboard",
      component: RouterView,
      meta: {
        auth: true,
      },
      children: [
        {
          path: "",
          name: "Dashboard",
          component: () => import("@/views/Dashboard"),
        },
        {
          path: "add-card",
          name: "Add Card",
          component: () => import("@/views/CardAdd"),
        },
        {
          path: "admin",
          name: "Admin",
          component: () => import("@/views/Admin"),
        },
      ],
    },
    {
      name: "Register",
      path: "/register",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/Register"),
    },
    {
      name: "Verify",
      path: "/verify",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/Verify"),
    },
    {
      name: "Login",
      path: "/login",
      component: () => import("@/views/Login"),
    },
  ],
})

router.beforeEach((to, from, next) => {
  const requireAuth = !!to.matched.find((route) => route.meta.auth)
  if (!requireAuth) {
    next()
    return
  }

  const user = store.get.user()
  if (!user) {
    next({ name: "Login", query: { redirect: to.fullPath } })
    return
  }

  next()
})
export default router
